import { render, staticRenderFns } from "./editOrderModel.vue?vue&type=template&id=f03f4d96&scoped=true&"
import script from "./editOrderModel.vue?vue&type=script&lang=js&"
export * from "./editOrderModel.vue?vue&type=script&lang=js&"
import style0 from "./editOrderModel.vue?vue&type=style&index=0&id=f03f4d96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03f4d96",
  null
  
)

export default component.exports